import * as web3 from "@solana/web3.js"
import { BILLBOARD_PROGRAM_ID } from "../utils/constants"
import { BN } from "@coral-xyz/anchor"

export class Auction {

	pubkey: web3.PublicKey
	provider: web3.PublicKey
	startTime: number
	startPrice: number
	minBidDelta: number
	expiration: number
	currentPrice: number
	highestBidder?: web3.PublicKey
	active: boolean
	reward: boolean

	constructor(
		pubkey: web3.PublicKey,
		provider: web3.PublicKey,
		startTime: number,
		startPrice: number,
		minBidDelta: number,
		expiration: number,
		currentPrice: number,
		active: boolean,
		reward: boolean,
		highestBidder?: web3.PublicKey,
	) {
		this.pubkey = pubkey
		this.provider = provider
		this.startTime = startTime
		this.startPrice = startPrice
		this.minBidDelta = minBidDelta
		this.expiration = expiration
		this.currentPrice = currentPrice
		this.highestBidder = highestBidder
		this.active = active
		this.reward = reward
	}



	static findAddress(providerPda: web3.PublicKey, startTime: number) {

		const time = new BN(startTime);
		const byteArray = time.toArray('le', 8);

		return web3.PublicKey.findProgramAddressSync(
			[Buffer.from("auction"), providerPda.toBuffer(), Buffer.from(byteArray)]
			, new web3.PublicKey(BILLBOARD_PROGRAM_ID)
		)
	}
}


